import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import CreditCardIcon from '../Partials/InternetPaymentDigits/CreditCardIcon';
import { reportDWH, setOtpDetails, goToPage } from '../saleJetBlockSlice';
import { validateInternetPaymentDigitsAsync } from '../saleBlockAsyncThunk';
import './internetPaymentDigitsPage.scss';

const InternetPaymentDigitsPage = (props) => {
  const [digits, setDigits] = useState(['', '', '', '']);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    props.reportDWH({
      actionType: 'Payment Digits',
      status: 'Ongoing',
      messageText: 'Internet Payment Digits Page Displayed',
    });
  }, []);

  const digitValue = digits.join('');

  const handleDigitChange = (index, value) => {
    const cleaned = value.replace(/\D/g, '').slice(-1);
    const next = [...digits];
    next[index] = cleaned;
    setDigits(next);
    setErrorMsg('');
    if (cleaned && index < 3) {
      document.getElementById(`payment-digit-${index + 1}`)?.focus();
    }
  };

  const handleDigitPaste = (event) => {
    event.preventDefault();
    const pasted = (event.clipboardData?.getData('text') || '').replace(/\D/g, '').slice(0, 4);
    if (!pasted) {
      return;
    }
    setDigits([pasted[0] || '', pasted[1] || '', pasted[2] || '', pasted[3] || '']);
    document.getElementById(`payment-digit-${Math.min(pasted.length, 3)}`)?.focus();
  };

  const handleDigitKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !digits[index] && index > 0) {
      document.getElementById(`payment-digit-${index - 1}`)?.focus();
    }
  };

  const handleContinue = async () => {
    if (digitValue.length !== 4) {
      setErrorMsg('אנא הזן 4 ספרות אחרונות');
      return;
    }

    const action = await props.validateInternetPaymentDigitsAsync(digitValue);
    if (validateInternetPaymentDigitsAsync.rejected.match(action)) {
      setErrorMsg('המספר שהקלדתם לא תואם את זה שיש אצלנו, שננסה שוב?');
      return;
    }

    const body = action.payload;
    props.setOtpDetails({
      otpTicketId: body.message,
      otpIdentity: props.otpDetails.otpIdentity,
      otpFlow: 'internetPaymentContactOtp',
      customerEmail: body.extra?.customerEmail || '',
      otpPhone: body.extra?.contactNumber || props.otpDetails.otpPhone,
      needsPaymentDigits: false,
      restrictedCodeRequired: Boolean(body.restrictedCodeRequired),
    });
    props.goToPage('otpVerifyCode');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleContinue();
  };

  return (
    <div className='slideAnimation internet-payment-digits-page'>
      <div className='sale-page-content full-width'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          <div className='internet-payment-digits'>
            <CreditCardIcon />
            <h1 className='internet-payment-digits__title'>
              <span>חשוב לנו לוודא שמדובר בך</span>
              <span>ולא באף אחד אחר</span>
            </h1>
            <h2 className='internet-payment-digits__subtitle'>
              מהן 4 הספרות האחרונות של אמצעי התשלום?
            </h2>
            <div className='internet-payment-digits__inputs'>
              {digits.map((digit, index) => (
                <input
                  key={index}
                  id={`payment-digit-${index}`}
                  className='internet-payment-digits__input'
                  type='text'
                  inputMode='numeric'
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleDigitChange(index, e.target.value)}
                  onPaste={handleDigitPaste}
                  onKeyDown={(e) => handleDigitKeyDown(index, e)}
                  autoComplete={index === 0 ? 'one-time-code' : 'off'}
                  autoFocus={index === 0}
                />
              ))}
            </div>
            {errorMsg ? <p className='internet-payment-digits__error'>{errorMsg}</p> : null}
          </div>
        </form>
        <SaleFooter
          isDisplayFooter={true}
          btnText='המשך'
          onclick={handleContinue}
          formid='saleJet'
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  otpDetails: state.saleJetBlock.otpDetails,
});

const mapDispatchToProps = {
  reportDWH,
  validateInternetPaymentDigitsAsync,
  setOtpDetails,
  goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(InternetPaymentDigitsPage);
